import { useQuery } from '@tanstack/react-query';
import { GeoReportUsageResponse } from '../../../models/geo-report/GeoReportResponse';
import { getGeoReportUsage } from '../../../services/geo-report/GeoReportService';
import { GET_GEO_REPORT_USAGE } from '../../query/geo-report/keys';
import { useAccount } from '../../../contexts/account/AccountContexts';

export const useGetGeoReportUsage = () => {
  const { accountResponse } = useAccount();
  const { data, isLoading } = useQuery<GeoReportUsageResponse>({
    queryKey: [GET_GEO_REPORT_USAGE, accountResponse?.accountId],
    queryFn: () => getGeoReportUsage(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return { data, isLoading };
};